import { createContext } from 'react';

import type { TGeoInfoData } from './models';

const GeoInfo = createContext<TGeoInfoData>(undefined);
const [Provider, Consumer] = [GeoInfo.Provider, GeoInfo.Consumer];

export { Provider as GeoInfoProvider, Consumer, GeoInfo };
